(function () {
  function getColorOptionIndex() {
    // Zoekt de index van de kleur-optie (0-based)
    const colorKeywords = ['kleur', 'color', 'colour'];
    const optionLabels = document.querySelectorAll('[data-option-name]');
    for (let i = 0; i < optionLabels.length; i++) {
      const name = optionLabels[i].dataset.optionName?.toLowerCase() || '';
      if (colorKeywords.some(k => name.includes(k))) return i;
    }
    return 0; // fallback: eerste optie
  }

  function findMediaForColor(productData, colorValue, colorOptionIndex) {
    // Zoek de eerste variant met deze kleur die een featured_media heeft
    const match = productData.variants.find(v => {
      const optionVal = v[`option${colorOptionIndex + 1}`];
      return optionVal?.toLowerCase() === colorValue?.toLowerCase() && v.featured_media;
    });
    return match?.featured_media?.id || null;
  }

  function swapImageForColor(productInfoEl, colorValue, colorOptionIndex) {
    const productDataEl = productInfoEl.querySelector('[data-product-json]') 
      || document.querySelector('[data-product-json]');
    if (!productDataEl) return;

    let productData;
    try {
      productData = JSON.parse(productDataEl.textContent);
    } catch (e) {
      return;
    }

    const mediaId = findMediaForColor(productData, colorValue, colorOptionIndex);
    if (!mediaId) return;

    // Gebruik de bestaande updateMedia methode van Relay
    const mediaEl = productInfoEl.querySelector(`[data-image-id="${mediaId}"]`);
    if (!mediaEl) return;

    const id = mediaEl.getAttribute('data-media-id');
    mediaEl.dispatchEvent(new CustomEvent('theme:media:select', {
      bubbles: true,
      detail: { id }
    }));

    // Scroll naar afbeelding op desktop
    if (!window.theme?.isMobile) {
      const top = mediaEl.getBoundingClientRect().top;
      window.theme?.scrollTo?.(top);
    } else {
      const mediaList = productInfoEl.querySelector('[data-product-media-list]');
      mediaList?.scrollTo({ left: mediaEl.offsetLeft });
    }
  }

  function initColorSwap() {
    document.querySelectorAll('product-info').forEach(productInfoEl => {
      productInfoEl.addEventListener('change', function (e) {
        const input = e.target;
        if (!input.matches('input[type="radio"], select')) return;

        const optionName = input.closest('[data-option-name]')?.dataset.optionName?.toLowerCase() || '';
        const colorKeywords = ['kleur', 'color', 'colour'];
        if (!colorKeywords.some(k => optionName.includes(k))) return;

        const colorValue = input.value || input.options?.[input.selectedIndex]?.value;
        if (!colorValue) return;

        const colorOptionIndex = getColorOptionIndex();
        swapImageForColor(productInfoEl, colorValue, colorOptionIndex);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSwap);
  } else {
    initColorSwap();
  }
})();